
export default {
  'button_reset': 'Reset',
  'login': 'Login',
  'email': 'Email',
  'password': 'Password',
  'home': 'Home',
  'global_yes': 'Yes',
  'global_no': 'No',
  'login_enter_mail_and_password': 'Please enter your email and password.',
  'login_enter_valid_mail': 'Please enter a valid email.',
  'login_error': 'An error occurred during the login. Please try again later or contact the terra team if the problem persists.',
  'login_error_email_not_registered': 'This email is not registered',
  'login_error_password_not_correct': 'This password is not correct',
  'login_password_forgot': 'I forgot my password',
  'pw_required': 'Password is required',
  'pw_must_match': 'Passwords must match.',
  'pw_min_3_char': 'Password must be at least 3 characters.',
  'pw_min_4_char': 'Password must be at least 4 characters long.',
  'pw_incorrect': 'Incorrect password',
  'register': 'Register',
  'reset_password_email_not_found': 'This email address is not registered',
  'reset_password_enter_email': 'Please enter your email',
  'reset_password_error': 'An error ocurred. Contact your terra team.',
  'reset_password_go_to_login': 'Go to login page',
  'reset_password_instructions_sent': 'An email has been sent to your account with instructions on how to reset your password.',
  'reset_password_send_submit': 'Send instructions',
  'reset_password_submit': 'Save',
  'reset_password_success_message': 'Great!<br>The password has been updated.',
  'reset_password_title': 'Reset your password',
  'reset_password_title_send': 'Forgot password ?',
  'reset_password_token_invalid': 'The link is no longer valid.',
  'setting_title': 'Personal Data',
  'setting_email': 'Edit email address',
  'setting_email_save': 'Save new email',
  'setting_email_success': 'Email successfully changed',
  'setting_password': 'Change Password',
  'setting_password_save': 'Save new password',
  'setting_password_success': 'Password successfully changed',
  'setting_current_pw': 'Current Password',
  'setting_new_pw': 'New Password',
  'setting_confirm_new_pw': 'Confirm New Password',
  'setting_profile': 'Contact details',
  'setting_profile_save': 'Save profile',
  'setting_profile_success': 'Profile successfully changed',
  'sign_up_confirm_pw': 'Confirm password',
  'sign_up': 'Sign up',
  'sign_up_alert_registrations_closed_1': 'Sorry, registrations to became a member in 2019 are closed.',
  'sign_up_alert_registrations_closed_2': 'Still, you can sign up and we are going to contact you as soon as we have a free spot.',
  //'sign_up_accept': 'I accept that TERRA uses my personal data respecting the GDPR. More information on the TERRA privacy policy ',
  'sign_up_accept': 'I accept that TERRA uses my personal data according to ',
  'sign_up_policy': 'the TERRA privacy policy',
  'signup_policy_link': 'contact-us',
  'email_valid': 'Doesn\'t look like a valid email.',
  'email_required': 'What\'s your email address?',
  'email_error_exist': 'The specified email address is already in use',
  'email_error_other': 'An error ocurred in this field',
  'first_name': 'First Name',
  'first_name_required': 'A first name is required',
  'last_name': 'Last Name',
  'last_name_required': 'A last name is required',
  'phone_number': 'Phone Number',
  'phone_number_required': 'A phone number is required',
  'phone_number_max': 'Phone number is too long',
  'address1': 'Address',
  'address1_required': 'An address is required',
  'address2': 'Address 2',
  'zip': 'ZIP',
  'zip_required': 'A ZIP code is required',
  'city': 'City',
  'city_required': 'A city is required',
  'country': 'Country',
  'country_required': 'A country is required',
  'data_authorization': 'I agree to TERRA use my personal data only in TERRA environment',
  'pickup_option': 'Pickup Option',
  'pickup_option_required': 'Pickup option is required',
  'date': 'Date',
  'main_commit': 'I commit to',
  'main_commit_text_1': 'Remain a member during the whole current season, even if I don’t pay in one go',
  'main_commit_text_2': 'Transfer the payment(s) duly and on time on the bank account below',
  'main_commit_text_3': 'Pick up my share of the harvest on a weekly basis',
  'main_logo_image': 'TERRA-CSAwhite.png',
  'main_membership_entitles': 'Every membership entitles you to 1 share of the harvest',
  'main_slogan_1': 'Where you become a member!',
  'main_slogan_2': 'Where you manage your vegetables!',
  'main_title': 'TERRA',
  'main_subtitle': 'Community Supported Agriculture (CSA)',
  'main_signup': 'SIGN UP',
  'main_signup_message': 'Join the TERRA adventure now!',
  'main_login': 'LOGIN ',
  'main_login_message': 'If you are already a member of TERRA!',
  'main_as_member': 'AS A MEMBER',
  'main_rights': 'I have a right to',
  'main_rights_text_1': 'Receive a share of the TERRA harvests during the current season',
  'main_rights_text_2': 'Participate in workshops organised by TERRA at a reduced fee (-10%)',
  'main_rights_text_3': 'Join the festivities and activities on the fields',
  'main_understand': 'I understand that',
  'main_understand_text_1': 'Harvests are subject to seasonal variations, natural risks and the producers’ experience',
  'main_understand_text_2': 'The producers do their best to obtain abundant harvests of an excellent quality',
  'main_understand_text_3': 'The beginning and the end of the season may vary, depending on conditions (about late April to beginning of December)',
  'main_video_title': 'This is how terra works !',
  'main_video_legend': 'Video made by Carles Xiberta',
  'footer_contact_label': 'Contact',
  'footer_address_label': 'Terra Garden',
  'footer_postal_address_label': 'Postal Address',
  'footer_account_label': 'Bank account',
  'footer_follow_us_label': 'Follow us',
  'membership_at': ' at ',
  'membership_from': ' from ',
  'membership_to': ' to ',
  'membership': 'Membership',
  'membership_alert_no_registrations': 'The coming season has not been activated yet for registrations',
  'membership_alert_no_basket_1': 'Open registrations!',
  'membership_alert_no_basket_2': 'You have not signed up yet for your basket in the season ',
  'membership_alert_no_payment_1': 'Pending payment!',
  'membership_alert_no_payment_2': 'We have not received a payment yet for your basket in ',
  'membership_amount': 'Amount',
  'membership_basket': 'Basket',
  'membership_basket_active': 'Active',
  'membership_basket_waiting_payment': 'Waiting for payment',
  'membership_basket_waiting_activation': 'Waiting for activation',
  'membership_baskets': 'basket (s)',
  'membership_button_edit': 'Edit profile',
  'membership_button_create_basket': 'Create new basket',
  'membership_season_label': 'Season',
  'membership_open_registration_label': 'Open registrations for season',
  'membership_date': 'Date',
  'membership_deadline': 'Deadline',
  'membership_deadline_approaching': 'Payment deadline approaching',
  'membership_description': 'Manage your baskets and your extra products',
  'membership_every': 'Every ',
  'membership_extras': 'Extras',
  'membership_first_pickup': 'First pickup',
  'membership_last_pickup': 'Last pickup',
  'membership_name': 'Name',
  'membership_payment': 'Payment',
  'membership_paid': 'Received Payment',
  'membership_phone': 'Phone',
  'membership_total': 'Total to pay',
  'membership_baskets_alert_activated_1': 'Basket activated',
  'membership_baskets_alert_activated_2': 'It is only possible to edit the pickup option',
  'membership_baskets_create': 'Create Basket',
  'membership_baskets_edit': 'Edit Basket',
  'membership_baskets_emails_title': 'Additional email addresses',
  'membership_baskets_emails_text': 'If you would like to receive emails for TERRA members on an additional email address, please add the email address here.',
  'membership_baskets_extras': 'Extras',
  'membership_baskets_extra_disabled': 'Not available',
  'membership_baskets_member_type_title': 'I am ...',
  'membership_baskets_member_type_required': 'Type of member is required',
  'membership_baskets_member_type_option_returning': '... a returning member.',
  'membership_baskets_member_type_option_new': '... a new member.',
  'membership_baskets_member_type_reference': 'If you got to know TERRA thanks to another member, please mention his/her name here, so that we can thank him/her:',
  'membership_baskets_member_type_reference_required': 'The member name is required',
  'membership_baskets_more_info': '... more information',
  'membership_baskets_num_payments': 'Number of payments',
  'membership_baskets_payment_deadlines': 'Payment deadlines',
  'membership_baskets_deadline_1': 'First deadline',
  'membership_baskets_deadline_2': 'Second deadline',
  'membership_baskets_deadline_3': 'Third deadline',
  'membership_baskets_deadline_4': 'Fourth deadline',
  'membership_baskets_prices_title': 'Membership options',
  'membership_baskets_prices_required': 'The membership option is required',
  'membership_baskets_subtitle': '',
  'membership_baskets_create_title': 'Create basket',
  'membership_baskets_edit_title': 'Edit basket',
  'membership_baskets_total': 'Total',
  'membership_edit_save': 'Save',
  'membership_edit_title': 'Edit Profile',
  'schedule': 'Schedule',
  'schedule_alert_active_no_basket': 'Your TERRA basket has not been activated yet for the current season, hence no pickup data is available.',
  'schedule_alert_no_active_no_registrations_title': 'Hello,',
  'schedule_alert_no_active_no_registrations': 'We thank you for your interest in becoming a member of TERRA!<br>Registrations for the 2021 season are unfortunately closed!<br>You can still enjoy our vegetables by visiting the TERRA stand in Bonnevoie on Place Léon XIII, every Saturday between 10 a.m. and 12 p.m. (from May to early December).<br>And who knows, you might want to register as a member next year?<br>See you soon !<br>The TERRA team',
  'schedule_alert_registrations_no_basket_title': 'Open registrations!',
  'schedule_alert_registrations_no_basket': 'You can now register to become a member in the coming season. <strong>Click here.</strong>',
  'schedule_alert_no_payment_1': 'Pending payment!',
  'schedule_alert_no_payment_2': 'We have not received a payment yet for your basket in the coming season. Click here for more details!',
  'schedule_help_out_button': 'I want to help out',
  'schedule_help_out_remove_button': 'I cannot help out',
  'schedule_help_out_instruction_title': 'You signed up to help at this pick-up',
  'schedule_help_out_instruction': 'We kindly ask you to come 20 mins. before the beginning of the pick-up and to stay until the end. Thank you for your help!',
  'schedule_help_out_title': 'Do you want to sign up to help at this pick-up?',
  'schedule_change_default': 'Change Default',
  'schedule_loading': 'Loading...',
  'schedule_location': 'Location:',
  'schedule_pickup_note': 'Pickup note:',
  'schedule_will_be_pickedup_by': 'Will be picked up by:',
  'schedule_cannot_pickup': 'You won\'t come to the pickup',
  'schedule_user_note': 'Note:',
  'schedule_note': 'Note:',
  'schedule_move_to': 'Move to:',
  'schedule_wont_come': 'I won\'t come.',
  'schedule_properties': 'Change your pickup properties',
  'schedule_delegate': 'Delegate:',
  'schedule_not_default_location': 'This pickup is not at its default location.',
  'schedule_pickup_contact': 'Pickup contact',
  'delegate_name': 'Name',
  'default': 'default',
  'save': 'Save',
  'cancel': 'Cancel',
  'edit': 'Edit',
  'picked_up': 'Picked up',
  'not_picked_up': 'Not picked up',
  'pickup_location_map': 'Pickup location map',
  'select_alternative': 'Select alternative',
  'default_title': 'Set default pickup option',
  'default_only_future': 'Only pickups in the future will be affected.',
  'default_detail_start': 'I want to pickup my ',
  'default_detail_end': '. basket at:',
  'select_pickup_option': 'Select a pickup option',
  'day_0': 'Sunday',
  'day_1': 'Monday',
  'day_2': 'Tuesday',
  'day_3': 'Wednesday',
  'day_4': 'Thursday',
  'day_5': 'Friday',
  'day_6': 'Saturday',
  'shortmonth_0': 'Jan',
  'shortmonth_1': 'Feb',
  'shortmonth_2': 'Mar',
  'shortmonth_3': 'Apr',
  'shortmonth_4': 'May',
  'shortmonth_5': 'Jun',
  'shortmonth_6': 'Jul',
  'shortmonth_7': 'Aug',
  'shortmonth_8': 'Sep',
  'shortmonth_9': 'Oct',
  'shortmonth_10': 'Nov',
  'shortmonth_11': 'Dec'
};



// WEBPACK FOOTER //
// ./client/app/services/translation/translation.en.ts